import styled from 'styled-components'

import { type EventInfo } from '~/features/general-participation/types/general-participation'
import { type OngoingEventResponse } from '~/features/main/apis/mainContents'
import ImageFromBucket from '~/shared/components/common/ImageFromBucket'
import Tag from '~/shared/components/tags/Tag'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'
import { fDateKo } from '~/shared/utils/format-date'

interface Props {
  ongoingEvent?: OngoingEventResponse
  data: EventInfo
  tab?: any
}

function GeneralTopSection({ ongoingEvent, data }: Props) {
  const { start_date, place } = data
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium
  const titleText = isMobile
    ? `${ongoingEvent?.data.eventInfo.name} 이벤트 참가 입장권 구매`
    : `${ongoingEvent?.data.eventInfo.name} 이벤트 참가\n입장권 구매`

  return (
    <Wrapper>
      <Title
        dangerouslySetInnerHTML={{
          __html: titleText,
        }}
      />
      <BackgroundImage
        src="assets/background/general-only-bg-2560.webp"
        alt="Background Image"
      />
      <TagContainer>
        <TagBox>
          <Tag $size={'md'} $variant={'white'}>
            이벤트 일자
          </Tag>
          <TagText>{fDateKo(start_date)}</TagText>
        </TagBox>
        <TagBox>
          <Tag $size={'md'} $variant={'white'}>
            이벤트 장소
          </Tag>
          <TagText>{place}</TagText>
        </TagBox>
      </TagContainer>
    </Wrapper>
  )
}

export default GeneralTopSection

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: flex-start;

  box-sizing: border-box;
  margin-top: 124px;

  @media ${theme.device.large} {
    gap: 20px;
    height: auto;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    margin-top: 56px;
  }
`

const BackgroundImage = styled(ImageFromBucket)`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  width: 100%;
  height: 550px;

  object-fit: cover;
  background-color: ${theme.colors.pink_2};

  @media ${theme.device.medium} {
    height: 450px;
    object-fit: cover;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 59px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 28px;
    line-height: 40px;
  }
`

const TagContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
`
const TagText = styled.span`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;

  @media ${theme.device.medium} {
    font-size: 18px;
  }
`
